import { takeLatest } from 'redux-saga/effects';
import {
  AngebotsId,
  ANTRAGSNUMMER_EVENTS,
  GlobalActions,
  ZAEHLSTUECKEREQUEST,
} from '@ps20-frontend/shop-integration-redux';
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export const updateAppActionsGenerator = ({ appId, angebotsId }: AngebotsId) => {
  return [
    new GlobalActions().antragsnummerRequested(appId, angebotsId),
    new GlobalActions().updateZaehlstuecke(),
  ];
};

export const updateAppSuccessActions = () => [
  GlobalActions.ANTRAGSNUMMER_GENERATED,
  GlobalActions.ZAEHLSTUECKE_RECEIVED,
];

export const updateAppFailActions = () => [
  ZAEHLSTUECKEREQUEST.ZAEHLSTUECKE_REQUEST_FAILED,
  ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
];

export const updateAppAndTarifiere = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(
    updateAppActionsGenerator,
    updateAppSuccessActions,
    updateAppFailActions,
  ),
);

export function* watchTarifierungBeibehaltung() {
  yield takeLatest(GlobalActions.TARIFIERUNG_TRIGGERED_BEIBEHALTUNG, updateAppAndTarifiere);
}
